import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import apiClient from '../../api/client';

export const VoiceMinutesBadge = () => {
  const [mins, setMins] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      apiClient.request('/api/billing/voice-minutes')
        .then(v => { if (alive) setMins(v.remaining_minutes); })
        .catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (mins === null) return null;
  const low = mins <= 10;
  return (
    <a
      href="/hearts"
      title={low ? 'Running low — top up with a pack' : 'Voice minutes remaining this month'}
      className={`flex items-center gap-1 px-2 py-1 rounded-full text-[11px] font-bold no-underline transition-colors ${
        low ? 'bg-red-100 text-red-600 hover:bg-red-200' : 'bg-purple-100 text-purple-700 hover:bg-purple-200'
      }`}
      data-testid="voice-minutes-badge"
    >
      <Clock size={12} />
      {mins}m
    </a>
  );
};
